import { Route } from '@angular/router';
import { LineSelectionComponent } from '@features/activity-types/change-carrier/line-selection/line-selection.component';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
import { DeviceDetailsComponent } from '@features/shopping/device-details/device-details.component';
import { DeviceListComponent } from '@features/shopping/device-list/device-list.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const change_carrier_routes: Route[] = [
  {
    path: 'line-selection',
    component: LineSelectionComponent,
    title: 'Select Line',
    data: { order_type_id: 5 }
  },
  {
    path: 'device-list',
    component: DeviceListComponent,
    title: 'Select Device',
    data: { order_type_id: 5 }
  },
  {
    path: 'device-details',
    component: DeviceDetailsComponent,
    title: 'Customize Device',
    data: { order_type_id: 5 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons'
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 5 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 5 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
